import UI_THEME_DEFAULT from './labels/UI_THEME_DEFAULT';
import UI_THEME_BANVOX from './labels/UI_THEME_BANVOX';
import UI_THEME_AVENTIS from './labels/UI_THEME_AVENTIS';
import UI_THEME_MILENIO from './labels/UI_THEME_MILENIO';
import UI_THEME_MERITO from './labels/UI_THEME_MERITO';
import { environment } from 'src/environments/environment';

const customLabels = {
  UI_THEME_DEFAULT,
  UI_THEME_BANVOX,
  UI_THEME_AVENTIS,
  UI_THEME_MILENIO,
  UI_THEME_MERITO,
};

const environmentTheme = environment.uiTheme;

let UIDefaultTheme =
  customLabels[environmentTheme as keyof typeof customLabels];

if (!UIDefaultTheme) {
  UIDefaultTheme = customLabels.UI_THEME_DEFAULT;
}

export default UIDefaultTheme;
